import React from "react";
import { ThemeColors } from "../../colors";
import TrustHero from "../sections/trust-hero/trust-hero";
import BookExplore from "../sections/book-explore/book-explore";
import ExpertExplore from "../sections/expert-explore/expert-explore";
import PreOrder from "../pre-order/pre-order";
import ExpertMarquee from "../sections/expert-marquee/expert-marquee";

export default function AuthorityHome() {
  return (
    <div style={{ backgroundColor: ThemeColors.OffWhite, minHeight: "100vh", width: "100%" }}>
      <TrustHero />
      <ExpertMarquee />
      <ExpertExplore />
      <BookExplore />
      {/* <LifespanGrid /> */}
      {/* <Media /> */}
      <PreOrder />
    </div>
  );
}
